import axios from 'axios';
import { environment } from 'environment';
import qs from 'qs';

/**
 * Axios instance for all `query` api requests.
 *
 * An `axios` instance utilising `axios-cache-adapter` and `localforage` for
 * caching responses to localStorage.
 */
const queryApi = axios.create({
  // adapter: getDefaultCache().adapter,
  baseURL: `${environment.endpoint('query')}/query/api`,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export default queryApi;
